import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../context/authContext';
import CalledService from '../../../services/resource/calledService';
import { useWebSocket } from '../../../services/useWebSocket';
import { useParams } from 'react-router-dom';

import { ChatSection } from './sections/chat/ChatSection';
import { DatesComponent } from './sections/dateComponent/DatesComponent';
import { AttachmentsComponent } from './sections/Attachments/AttachmentsComponent';
import { returnDate } from '../../../utils/formatDate';
import { TicketInfoCard } from './TicketInfo/TicketInfoCard';
import { ActionSection } from './sections/actionsSection/ActionsSection';
import NotificationAudio from '../../../assets/sounds/simple-notification-receiver.mp3';
import useSound from 'use-sound';

const initalValues = {
    assigneeEmail: "",
    assigneeName: "",
    attachments: [],
    attributes: {},
    branchCode: "",
    branchName: "",
    comments: [],
    creationDate: "",
    description: "",
    serviceTypeImage: "",
    id: 0,
    ticket: "",
    priority: "",
    requesterEmail: "",
    requesterName: "",
    serviceType: {
        attributes: {
            var: ''
        }
    },
    serviceTypeDescription: "",
    solutionApplied: "",
    status: "RESOLVIDO",
    title: "",
    updateDate: "",
    userEmail: "",
    userName: "",
}
export const VisualizarChamado = ({ ticket }) => {
    const calledService = new CalledService();
    const { user } = useAuth();
    const { calledTicket } = useParams();
    const { connectWebSocket, isConnect, stompClient } = useWebSocket();
    const [audio] = useSound(NotificationAudio);

    const [currentTicket, setCurrentTicket] = useState(ticket);
    const [called, setCalled] = useState(initalValues);
    const [files, setFiles] = useState([]);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        const fetchTicketData = () => {
            if (calledTicket) {
                setCurrentTicket(calledTicket);
                listCalledByTicket(calledTicket);
            } else {
                listCalledByTicket(currentTicket);
            }
        };

        fetchTicketData();
    }, []);

    useEffect(() => {
        const fetchImages = async () => {
            const filesUrls = [];
            for (const obj of called.attachments) {
                filesUrls.push(obj);
            }

            setFiles(filesUrls);
        };

        fetchImages();
    }, [called.attachments]);

    useEffect(() => {
        connectWebSocket();

        return () => {
            if (stompClient && !isConnect) {
                stompClient.disconnect();
            }
        };
    }, []);

useEffect(() => {
    const originalTitle = document.title;

    if (isConnect && stompClient) {
        const subscription = stompClient.subscribe(`/comment/${currentTicket}`, (message) => {
            const newComment = JSON.parse(message.body);
            setComments(prev => [...prev, newComment]);

            // Se for mensagem de outro usuário (readSender = true), toca som e altera aba
            if (newComment.readSender) {
                audio();

                // Adiciona indicador (1) na aba
                document.title = `(1) ${originalTitle}`;
            }
        });

        // Restaura título quando o usuário volta a visualizar a aba
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                document.title = originalTitle;
            }
        };

          const resetTitle = () => {
            document.title = originalTitle;
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        document.addEventListener("click", resetTitle); 

        // Cleanup
        return () => {
            subscription.unsubscribe();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            document.removeEventListener("click", resetTitle);
            resetTitle();
        };
    }
}, [stompClient, isConnect, currentTicket]);

    const listCalledByTicket = async (ticket) => {
        try {
            const response = await calledService.getCalledByTicket(ticket);
            setCalled(response.data);
            setComments(response.data.comments.sort((a, b) => a.id - b.id));
            setTimeout(() => {
            }, 300);
        } catch (error) {
            toast.error(error.response.data.message);
        }
    };

    const forceUpdate = () => {
        listCalledByTicket(currentTicket);
    };

    return (
        <>
            <div className='container'>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-2 space-y-6">
                        <TicketInfoCard
                            called={called}
                            ticket={called.ticket}
                            title={called.title}
                            description={called.description}
                            typeService={called.serviceTypeDescription}
                            status={called.status}
                            priority={called.priority}
                            branch={called.branchName}
                            creationDate={returnDate(called.creationDate)}
                            assigneeName={called.assigneeName}
                            serviceImage={called.serviceTypeImage}
                            attributes={called.attributes}
                            solutionApplied={called.solutionApplied}
                        />
                        <ChatSection
                            messages={comments}
                            user={user.sub}
                            service={calledService}
                            ticket={called.ticket}
                            status={called.status}
                            attComments={forceUpdate}
                        />
                    </div>
                    <div className="space-y-6">
                        <DatesComponent value={called} />
                        <AttachmentsComponent
                            files={files}
                            service={calledService}
                            id={called.id}
                            username={user.sub}
                        />
                        <ActionSection service={calledService} id={called.id} status={called.status} setStatus={(value) => setCalled(prev => ({ ...prev, status: value }))} />
                    </div>
                </div>
            </div>
        </>
    );
};